import { createFileRoute } from '@tanstack/react-router'
import { CatalogSearchPage } from '@/features/catalog-search/catalog-search-page'
import { validateCatalogSearch } from '@/features/catalog-search/search-state'

export const Route = createFileRoute('/_authenticated/catalog-search')({
  staticData: { title: 'Catalog Search' },
  validateSearch: validateCatalogSearch,
  component: CatalogSearchRoute,
})

function CatalogSearchRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <CatalogSearchPage
      search={search}
      onSearchChange={(nextSearch) => {
        void navigate({ search: nextSearch })
      }}
    />
  )
}
